<script setup lang="ts">
const { minWidth } = defineProps<{ minWidth?: string }>()
</script>

<template>
  <div class="horizontally-scrollable" :style="{ '--min-width': minWidth }">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.horizontally-scrollable {
  overflow-x: auto;
  width: 100%;
  
  > * {
    width: 100%;
    min-width: var(--min-width);
  }
}
</style>
